import { withUnconnectedRegularConnectionAtAllTimes } from './brick-initializer-helpers';
import {optionsCheckpoint} from "@modules/JourneyBuilder/Bricks/Checkpoints";

/**
 * Initialize the given child journey brick
 * @param {JourneyBrick} brick
 */
const initializeChildJourneyBrick = brick => {
  //https://datanext.atlassian.net/browse/DPN-3123
  //Child journey bricks may not have incoming connections, only outgoing connections
  const _registerConnection = brick.registerConnection;
  brick.registerConnection = function (connection) {
    if(connection.sourceBrickId !== brick.id) {
      connection.delete();
      return;
    }
    
    return _registerConnection.apply(this, arguments);
  }
  
  
  withUnconnectedRegularConnectionAtAllTimes(brick);
}

/**
 * Initialize the given parent journey brick
 * @param {JourneyBrick} brick
 */
const initializeParentJourneyBrick = brick => {
  //https://datanext.atlassian.net/browse/DPN-3123
  //Brick does not accept checkpoints - options checkpoint is required for valid connections
  const _registerConnection = brick.registerConnection;
  brick.registerConnection = function (connection) {
    connection.supportedCheckpoints = [optionsCheckpoint.name];
    return _registerConnection.apply(this, arguments);
  }
}

/**
 * Initialize the given journey brick
 * @param {JourneyBrick} brick
 */
const initialize = brick => {
  if(brick.isChildJourneyBrick) {
    initializeChildJourneyBrick(brick);
  } else {
    initializeParentJourneyBrick(brick);
  }
}

export { initialize };